import React from 'react'
import { UI } from '../../utils/styles'

export const ButtonPrimary = ({ onClick, disabled, children, className = '', type = 'button' }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`bg-sky-700 hover:bg-sky-800 active:bg-sky-900 text-white font-semibold py-3.5 ${UI.radius} ${UI.shadow} ${UI.transition} disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
  >
    {children}
  </button>
)

export const ButtonSecondary = ({ onClick, disabled, children, className = '', type = 'button' }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`${UI.glass} ${UI.border} ${UI.radius} ${UI.transition} text-slate-700 font-medium py-3 hover:bg-slate-50 active:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
  >
    {children}
  </button>
)

export const ButtonDanger = ({ onClick, disabled, children, className = '', type = 'button' }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className={`bg-red-500 hover:bg-red-600 active:bg-red-700 text-white font-semibold py-3 px-4 rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
  >
    {children}
  </button>
)
